require('typeface-noto-sans')
require('typeface-noto-serif')

module.exports = {
  background: '#fff',
  color: '#333',
  font: "'Noto Serif', serif",
  header: {
    font: "'Noto Sans', sans-serif",
  },
  footer: {
    font: "'Noto Sans', sans-serif",
  },
  heading: {
    font: "'Noto Sans', sans-serif",
  },
  figure: {
    font: "'Noto Sans', sans-serif",
  },
}
